export default function DatepickerService() {
    // TODO: comment what is value
    let value;

    return {
        getValue: () => value,
        setValue: (newValue) => value = newValue
    };
}
